<template>
    <div class="panel" @click="handleClick">
        <div class="left-box"><van-icon name="location-o" /></div>
        <div class="center-box">
            <div v-if="!flag_null">
                <span class="name">{{p_name}}</span>
                <span class="mobile">{{p_mobile}}</span>
            </div>
            <div v-if="!flag_null" class="address">{{p_address}}</div>
            <div v-if="flag_null" class="warning">{{warning_text}}</div>
        </div>
        <div class="right-box" v-if="p_enable_edit"><van-icon name="arrow" /></div>
    </div>
</template>

<script>
    export default {
        name: "AddressCard",
        props:{
            p_name:{
                type:String,
                default:'',
                required:false,
            },
            p_mobile:{
                type:String,
                default:'',
                required:false,
            },
            p_address:{
                type:String,
                default:'',
                required:false,
            },
            p_enable_edit:{
                type:Boolean,
                default:true,
                required:false,
            }
        },
        data(){
            return {
                flag_null:this.p_mobile == ''||this.p_mobile==null,
                // user_name:this.p_name,
                // user_mobile:this.p_mobile,
                // user_address:this.p_address,
                warning_text:this.p_mobile?'':'收货人信息未设置(点击设置)'
            }
        },
        watch:{
            p_mobile(val){
                this.flag_null = val == ''||val==null;
            },
        },
        methods:{
            handleClick(){
                if(this.p_enable_edit){
                    this.$emit('onClick');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .panel{
        background-color: #FFFFFF;
        min-height: 60px;
        .left-box{
            /*border: 1px solid red;*/
            padding: 0;
            display: inline-block;
            line-height: 60px;
            text-align: center;
            width: 30px;
            font-size: 24px;
            float: left;
            color: #E34928;
            van-icon{
                vertical-align: middle;
            }
        }
        .center-box{
            /*border: 1px solid blue;*/
            display: inline-block;
            padding-top: 4px;
            padding-left: 4px;
            .name{
                font-size: 16px;
                color: #333333;
            }
            .mobile{
                font-size: 12px;
                color: #666666;
                padding-left: 6px;
            }
            .address{
                padding-top: 4px;
                font-size: 12px;
                color: #333333;
            }
            .warning{
                padding-top: 12px;
                font-size: 14px;
                color: #666666;
                font-weight: bold;
            }
        }
        .right-box{
            display: inline-block;
            float: right;
            line-height: 60px;
            font-size: 20px;
            width: 40px;
            van-icon{
                vertical-align: middle;
            }
        }
    }
</style>
